/**
 * G-129 (OD-160): what the staging page says once a paper it uploaded has
 * been read — how many items the app created by itself and how many lines
 * still need a person. Pure, so the sentence is pinned by a spec.
 */
export function paperReadNotice(input: {
  supplierName: string;
  label: string;
  created: number;
  needCategory: number;
  sameName: number;
}): string {
  const parts: string[] = [];
  parts.push(input.created === 1 ? "1 item created" : `${input.created} items created`);
  if (input.needCategory > 0) {
    parts.push(input.needCategory === 1 ? "1 needs a category" : `${input.needCategory} need a category`);
  }
  if (input.sameName > 0) {
    parts.push(
      input.sameName === 1
        ? "1 shares a name with an existing item"
        : `${input.sameName} share a name with an existing item`,
    );
  }
  return `Read ${input.supplierName} ${input.label}: ${parts.join(", ")}.`;
}
